export function assertNever(value: never) {
  throw new Error(`This code should be unreachable, but received value: '${value}'.`);
}
